<template>
  <div class="member-container">
    <!-- 查询条件 -->
    <div class="search-form">
      <el-form :model="queryParams" inline>
        <el-form-item label="手机号">
          <el-input
            v-model="queryParams.phone"
            placeholder="请输入手机号"
            clearable
            style="width: 180px"
          />
        </el-form-item>
        <el-form-item label="会员昵称">
          <el-input
            v-model="queryParams.nickname"
            placeholder="请输入昵称"
            clearable
            style="width: 160px"
          />
        </el-form-item>
        <el-form-item label="注册渠道">
          <el-select
            v-model="queryParams.channel"
            placeholder="全部渠道"
            clearable
            style="width: 140px"
          >
            <el-option label="线上" value="ONLINE" />
            <el-option label="线下" value="OFFLINE" />
          </el-select>
        </el-form-item>
        <el-form-item label="会员分类">
          <el-select v-model="queryParams.memberCategory" placeholder="请选择" clearable style="width: 140px">
            <el-option label="普通会员" value="普通会员" />
            <el-option label="付费会员" value="付费会员" />
          </el-select>
        </el-form-item>
        <el-form-item label="有赞会员ID">
          <el-input
            v-model="queryParams.youzanId"
            placeholder="请输入有赞会员ID"
            clearable
            style="width: 160px"
          />
        </el-form-item>
        <el-form-item label="科脉会员ID">
          <el-input
            v-model="queryParams.kemaiUserId"
            placeholder="请输入科脉会员ID"
            clearable
            style="width: 160px"
          />
        </el-form-item>
        <el-form-item label="注册时间">
          <el-date-picker
            v-model="queryParams.registerTimeRange"
            type="datetimerange"
            range-separator="至"
            start-placeholder="开始时间"
            end-placeholder="结束时间"
            value-format="yyyy-MM-dd HH:mm:ss"
            style="width: 360px"
          />
        </el-form-item>
        <el-form-item label="最近消费时间">
          <el-date-picker
            v-model="queryParams.lastOrderTimeRange"
            type="datetimerange"
            range-separator="至"
            start-placeholder="开始时间"
            end-placeholder="结束时间"
            value-format="yyyy-MM-dd HH:mm:ss"
            style="width: 360px"
          />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="handleSearch">查询</el-button>
          <el-button icon="el-icon-refresh" @click="handleReset">重置</el-button>
          <el-button v-permission="'member:export'" type="warning" icon="el-icon-download" :loading="exportLoading" :disabled="exportStatus === 'RUNNING'" @click="handleExport">导出</el-button>
          <el-button v-permission="'member:import:csv'" type="success" icon="el-icon-upload2" @click="$router.push('/member/import-csv')">科脉导入</el-button>
          <el-button v-permission="'member:import:youzan'" type="primary" icon="el-icon-upload2" @click="$router.push('/member/import-youzan')">有赞导入</el-button>
        </el-form-item>
      </el-form>
    </div>

    <!-- 导出进度 -->
    <div v-if="exportTaskId" class="export-progress-section">
      <h3>导出进度</h3>

      <!-- 导出中 -->
      <div v-if="exportStatus === 'RUNNING'" class="loading-progress">
        <div class="progress-bar-cycling"></div>
        <div class="progress-message">
          {{ exportTask.message || '正在生成文件...' }}
          <span v-if="exportTask.total > 0">（{{ exportTask.processed }}/{{ exportTask.total }}）</span>
        </div>
      </div>

      <!-- 导出完成 -->
      <div v-else-if="exportStatus === 'DONE'" class="progress-result">
        <el-progress :percentage="100" status="success" :stroke-width="20"></el-progress>
        <div class="progress-info">
          <span>总计: <strong>{{ exportTask.total }}</strong></span>
          <span class="text-success">已完成</span>
        </div>
        <div v-if="exportTask.message" class="progress-message">{{ exportTask.message }}</div>
        <div class="action-buttons">
          <el-button icon="el-icon-close" @click="clearExportTask">关闭</el-button>
        </div>
      </div>

      <!-- 导出失败 -->
      <div v-else-if="exportStatus === 'ERROR'" class="progress-error">
        <el-alert :title="exportTask.message || '导出失败'" type="error" :closable="false" show-icon></el-alert>
        <div class="action-buttons">
          <el-button icon="el-icon-close" @click="clearExportTask">关闭</el-button>
        </div>
      </div>
    </div>

    <!-- 数据表格 -->
    <div class="content-wrapper">
      <el-table
        v-loading="tableLoading"
        :data="tableData"
        border
        stripe
        style="width: 100%"
      >
        <el-table-column prop="phone" label="手机号" min-width="130" align="center" fixed="left" />
        <el-table-column prop="nickname" label="会员昵称" min-width="120" align="center" show-overflow-tooltip />
        <el-table-column prop="channel" label="注册渠道" width="100" align="center">
          <template slot-scope="{ row }">
            <el-tag :type="row.channel === 'ONLINE' ? 'success' : 'warning'" size="small">
              {{ row.channel === 'ONLINE' ? '线上' : '线下' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="memberCategory" label="会员分类" min-width="110" align="center" show-overflow-tooltip />
        <el-table-column prop="shopName" label="归属店铺" min-width="130" align="center" show-overflow-tooltip />
        <el-table-column prop="youzanId" label="有赞会员ID" min-width="140" align="center" show-overflow-tooltip />
        <el-table-column prop="kemaiUserId" label="科脉会员ID" min-width="140" align="center" show-overflow-tooltip />
        <el-table-column prop="balance" label="余额" width="130" align="center">
          <template slot-scope="{ row }">
            <el-button
              type="text"
              size="small"
              :loading="row._balanceLoading"
              @click.stop="handleQueryBalance(row)"
              v-permission="'member:balance:query'"
            >
              <i class="el-icon-wallet" style="margin-right: 4px"></i>查询余额
            </el-button>
            <!-- 查询结果展示 -->
            <div v-if="row._balanceData && !row._balanceLoading" class="balance-result">
              <div class="bal-total">¥{{ row._balanceData.totalBalance }}</div>
              <div class="bal-split">
                本金: ¥{{ row._balanceData.principalBalance }} | 赠: ¥{{ row._balanceData.bonusBalance }}
              </div>
              <div v-if="row._balanceData.cardCount > 0" class="bal-cards">{{ row._balanceData.cardCount }}张卡</div>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="totalOrderCount" label="消费次数" width="90" align="center" />
        <el-table-column prop="totalOrderAmount" label="累计消费（元）" width="130" align="center">
          <template slot-scope="{ row }">{{ fmt(row.totalOrderAmount) }}</template>
        </el-table-column>
        <el-table-column prop="onlineOrderAmount" label="线上消费（元）" width="130" align="center">
          <template slot-scope="{ row }">{{ fmt(row.onlineOrderAmount) }}</template>
        </el-table-column>
        <el-table-column prop="offlineOrderAmount" label="门店消费（元）" width="130" align="center">
          <template slot-scope="{ row }">{{ fmt(row.offlineOrderAmount) }}</template>
        </el-table-column>
        <el-table-column prop="lastOrderTime" label="最近消费时间" min-width="170" align="center">
          <template slot-scope="{ row }">{{ fmtTime(row.lastOrderTime) }}</template>
        </el-table-column>
        <el-table-column prop="totalRefundAmount" label="累计退款（元）" width="130" align="center">
          <template slot-scope="{ row }">{{ fmt(row.totalRefundAmount) }}</template>
        </el-table-column>
        <el-table-column prop="totalRefundCount" label="退款单数" width="90" align="center" />
        <el-table-column prop="registerTime" label="注册时间" min-width="170" align="center">
          <template slot-scope="{ row }">{{ fmtTime(row.registerTime) }}</template>
        </el-table-column>
        <el-table-column label="操作" width="100" align="center" fixed="right">
          <template slot-scope="{ row }">
            <el-button type="text" size="small" @click="handleDetail(row)">详情</el-button>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <Pagination
        :total="total"
        :page.sync="queryParams.pageNum"
        :limit.sync="queryParams.pageSize"
        @pagination="getList"
      />
    </div>

    <!-- 详情弹窗 -->
    <el-dialog
      title="会员详情"
      :visible.sync="detailVisible"
      width="780px"
    >
      <el-descriptions :column="2" border size="small" v-if="detailData">
        <el-descriptions-item label="会员中心会员ID">{{ detailData.id }}</el-descriptions-item>
        <el-descriptions-item label="手机号">{{ detailData.phone }}</el-descriptions-item>
        <el-descriptions-item label="会员昵称">{{ detailData.nickname || '-' }}</el-descriptions-item>
        <el-descriptions-item label="注册渠道">
          <el-tag :type="detailData.channel === 'ONLINE' ? 'success' : 'warning'" size="small">
            {{ detailData.channel === 'ONLINE' ? '线上' : '线下' }}
          </el-tag>
        </el-descriptions-item>
        <el-descriptions-item label="会员分类">{{ detailData.memberCategory || '-' }}</el-descriptions-item>
        <el-descriptions-item label="归属店铺">{{ detailData.shopName || '-' }}</el-descriptions-item>
        <el-descriptions-item label="有赞会员ID">{{ detailData.youzanId || '-' }}</el-descriptions-item>
        <el-descriptions-item label="科脉会员ID">{{ detailData.kemaiUserId || '-' }}</el-descriptions-item>
        <el-descriptions-item label="余额（元）">{{ fmt(detailData.balance) }}</el-descriptions-item>
        <el-descriptions-item label="累计消费次数">{{ detailData.totalOrderCount || 0 }}</el-descriptions-item>
        <el-descriptions-item label="累计消费金额（元）">{{ fmt(detailData.totalOrderAmount) }}</el-descriptions-item>
        <el-descriptions-item label="线上消费金额（元）">{{ fmt(detailData.onlineOrderAmount) }}</el-descriptions-item>
        <el-descriptions-item label="门店消费金额（元）">{{ fmt(detailData.offlineOrderAmount) }}</el-descriptions-item>
        <el-descriptions-item label="最近消费时间">{{ fmtTime(detailData.lastOrderTime) || '-' }}</el-descriptions-item>
        <el-descriptions-item label="累计退款金额（元）">{{ fmt(detailData.totalRefundAmount) }}</el-descriptions-item>
        <el-descriptions-item label="累计退款订单数">{{ detailData.totalRefundCount || 0 }}</el-descriptions-item>
        <el-descriptions-item label="注册时间">{{ fmtTime(detailData.registerTime) || '-' }}</el-descriptions-item>
        <el-descriptions-item label="最后更新">{{ fmtTime(detailData.updateTime) }}</el-descriptions-item>
      </el-descriptions>
      <div slot="footer">
        <el-button @click="detailVisible = false">关 闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getMemberList, getMemberDetail, queryYouzanBalance } from '@/api/member'
import { submitExport, getExportTask, downloadExport } from '@/api/export'
import request from '@/utils/request'
import Pagination from '@/components/Pagination/index.vue'

export default {
  name: 'MemberManage',
  components: { Pagination },
  data() {
    return {
      queryParams: {
        phone: '',
        nickname: '',
        channel: '',
        memberCategory: '',
        youzanId: '',
        kemaiUserId: '',
        registerTimeRange: [],
        lastOrderTimeRange: [],
        pageNum: 1,
        pageSize: 10
      },
      tableLoading: false,
      exportLoading: false,
      tableData: [],
      total: 0,
      detailVisible: false,
      detailData: null,
      // 异步导出状态
      exportTaskId: null,
      exportStatus: '', // RUNNING / DONE / ERROR
      exportTask: {},
      exportPollingTimer: null
    }
  },
  created() {
    // 从URL参数读取手机号（如余额流水点击跳转）
    if (this.$route.query.phone) {
      this.queryParams.phone = this.$route.query.phone
    }
    this.getList()
    this.recoverExportProgress()
  },
  beforeDestroy() {
    this.stopExportPolling()
  },
  methods: {
    // 获取会员列表
    getList() {
      this.tableLoading = true
      const params = { ...this.queryParams }
      if (params.registerTimeRange && params.registerTimeRange.length === 2) {
        params.startTime = params.registerTimeRange[0]
        params.endTime = params.registerTimeRange[1]
      }
      delete params.registerTimeRange
      if (params.lastOrderTimeRange && params.lastOrderTimeRange.length === 2) {
        params.lastOrderStartTime = params.lastOrderTimeRange[0]
        params.lastOrderEndTime = params.lastOrderTimeRange[1]
      }
      delete params.lastOrderTimeRange

      getMemberList(params).then(res => {
        this.tableData = res.data.records || res.data.list || []
        this.total = res.data.total || 0
      }).catch(() => {
        this.tableData = []
        this.total = 0
      }).finally(() => {
        this.tableLoading = false
      })
    },

    // 查询
    handleSearch() {
      this.queryParams.pageNum = 1
      this.getList()
    },

    // 重置
    handleReset() {
      this.queryParams = {
        phone: '',
        nickname: '',
        channel: '',
        memberCategory: '',
        youzanId: '',
        kemaiUserId: '',
        registerTimeRange: [],
        lastOrderTimeRange: [],
        pageNum: 1,
        pageSize: 10
      }
      this.getList()
    },

    // 导出（异步）
    handleExport() {
      const params = { ...this.queryParams, pageNum: undefined, pageSize: undefined }
      if (params.registerTimeRange && params.registerTimeRange.length === 2) {
        params.startTime = params.registerTimeRange[0]
        params.endTime = params.registerTimeRange[1]
      }
      delete params.registerTimeRange
      delete params.lastOrderTimeRange

      this.exportLoading = true
      submitExport('member', params).then(res => {
        this.exportTaskId = res.data.taskId
        this.exportStatus = 'RUNNING'
        this.exportTask = { message: res.data.message || '正在生成文件...' }
        this.startExportPolling()
      }).catch(err => {
        this.$message.error(err.message || '导出提交失败')
      }).finally(() => {
        this.exportLoading = false
      })
    },

    // 恢复导出进度
    recoverExportProgress() {
      const cached = sessionStorage.getItem('memberExportTask')
      if (!cached) return
      try {
        const { taskId } = JSON.parse(cached)
        getExportTask(taskId).then(res => {
          const task = res.data
          if (task.status === 'RUNNING') {
            this.exportTaskId = taskId
            this.exportStatus = 'RUNNING'
            this.exportTask = task
            this.startExportPolling()
          } else if (task.status === 'DONE' || task.status === 'ERROR') {
            this.exportTaskId = taskId
            this.exportStatus = task.status
            this.exportTask = task
          } else {
            sessionStorage.removeItem('memberExportTask')
          }
        }).catch(() => {
          sessionStorage.removeItem('memberExportTask')
        })
      } catch (e) {
        sessionStorage.removeItem('memberExportTask')
      }
    },

    // 开始轮询导出进度
    startExportPolling() {
      this.stopExportPolling()
      sessionStorage.setItem('memberExportTask', JSON.stringify({ taskId: this.exportTaskId }))
      this.pollExportTask()
      this.exportPollingTimer = setInterval(() => {
        this.pollExportTask()
      }, 3000)
    },

    // 轮询导出任务
    pollExportTask() {
      getExportTask(this.exportTaskId).then(res => {
        const task = res.data
        this.exportTask = task
        this.exportStatus = task.status
        if (task.status === 'DONE' || task.status === 'ERROR') {
          this.stopExportPolling()
          if (task.status === 'DONE') {
            this.autoDownloadExport()
          }
        }
      }).catch(() => {
        this.exportStatus = 'ERROR'
        this.exportTask = { message: '查询进度失败' }
        this.stopExportPolling()
      })
    },

    // 停止轮询
    stopExportPolling() {
      if (this.exportPollingTimer) {
        clearInterval(this.exportPollingTimer)
        this.exportPollingTimer = null
      }
    },

    // 自动下载导出文件
    autoDownloadExport() {
      if (!this.exportTaskId) return
      downloadExport(this.exportTaskId).then(() => {
        this.$message.success('导出完成，文件已下载')
      }).catch(() => {
        this.$message.error('下载失败')
      })
    },

    // 清除导出任务
    clearExportTask() {
      this.exportTaskId = null
      this.exportStatus = ''
      this.exportTask = {}
      this.stopExportPolling()
      sessionStorage.removeItem('memberExportTask')
    },

    // 查看详情
    handleDetail(row) {
      getMemberDetail(row.id).then(res => {
        this.detailData = res.data
        this.detailVisible = true
      }).catch(() => {
        this.$message.error('获取详情失败')
      })
    },

    // 查询有赞储值卡余额（点击按钮触发）
    handleQueryBalance(row) {
      if (!row.phone) {
        this.$message.warning('该会员没有手机号，无法查询余额')
        return
      }
      // 设置 loading 状态
      this.$set(row, '_balanceLoading', true)
      this.$set(row, '_balanceData', null)

      queryYouzanBalance(row.phone).then(res => {
        const data = res.data
        if (data && data.totalBalance !== undefined) {
          this.$set(row, '_balanceData', data)
          // 如果有卡信息，在控制台打印详细数据
          if (data.cards && data.cards.length > 0) {
            console.debug('储值卡详情:', data.cards)
          }
        } else {
          this.$message.info('未查询到储值卡信息')
        }
      }).catch(err => {
        this.$message.error(err.message || '查询余额失败')
      }).finally(() => {
        this.$set(row, '_balanceLoading', false)
      })
    },

    // 金额格式化（后端已转元，展示两位小数）
    fmt(val) {
      if (val === null || val === undefined) return '0.00'
      return Number(val).toFixed(2)
    },

    // 时间格式化，将 ISO 格式中的 T 替换为空格
    fmtTime(val) {
      if (!val) return ''
      return String(val).replace('T', ' ')
    }
  }
}
</script>

<style lang="less" scoped>
.member-container {
  height: 100%;
}
.balance-result {
  margin-top: 4px;
  line-height: 1.4;
  .bal-total {
    font-weight: 600;
    color: #409EFF;
    font-size: 14px;
  }
  .bal-split {
    font-size: 11px;
    color: #909399;
    margin-top: 2px;
  }
  .bal-cards {
    font-size: 11px;
    color: #67C23A;
    margin-top: 1px;
  }
}
.extend-info-header:hover {
  color: #409EFF;
}

/* 导出进度 */
.export-progress-section {
  margin: 16px 20px;
  padding: 16px 20px;
  background: #FAFAFA;
  border-radius: 8px;
  border: 1px solid #EBEEF5;
  h3 {
    font-size: 16px;
    margin: 0 0 16px;
  }
  .loading-progress {
    .progress-bar-cycling {
      height: 20px;
      border-radius: 10px;
      background: #EBEEF5;
      position: relative;
      overflow: hidden;
      &::after {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        width: 30%;
        height: 100%;
        background: #409EFF;
        border-radius: 10px;
        animation: export-cycling 2s ease-in-out infinite;
      }
    }
    .progress-message {
      margin-top: 8px;
      color: #606266;
      font-size: 13px;
      text-align: center;
    }
  }
  .progress-result {
    .progress-info {
      display: flex;
      gap: 16px;
      margin-top: 12px;
      font-size: 14px;
    }
    .progress-message {
      margin-top: 8px;
      color: #606266;
      font-size: 13px;
    }
    .action-buttons {
      margin-top: 16px;
    }
  }
  .progress-error {
    .action-buttons {
      margin-top: 12px;
    }
  }
}

@keyframes export-cycling {
  0% { left: -30%; }
  50% { left: 100%; }
  100% { left: -30%; }
}

.text-success { color: #67C23A; }
</style>
